import { Slider } from '@/components/ui-kit/slider';
import { FormLabel } from '@/components/ui-kit/form';
import { InfoTooltip } from '@/components/ui-kit/info-tool-tip';
import { Switch } from '@/components/ui-kit/switch';

type SliderControlProps = {
  label: string;
  tooltipContent: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
  showSwitch?: boolean;
  switchChecked?: boolean;
  switchDisabled?: boolean;
  isMobile?: boolean;
};

export const SliderControl = ({
  label,
  tooltipContent,
  value,
  onChange,
  min,
  max,
  step,
  showSwitch = false,
  switchChecked = false,
  switchDisabled = false,
  isMobile = false,
}: SliderControlProps) => {
  const formatValue = (val: number) => {
    if (step < 1) {
      return val.toFixed(2);
    }
    return val.toString();
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <FormLabel className="flex items-center gap-2 text-base font-medium">
          {label}
          <InfoTooltip content={tooltipContent} />
        </FormLabel>
        {showSwitch && (
          <Switch
            checked={switchChecked}
            disabled={switchDisabled}
            className="scale-75 opacity-50"
          />
        )}
      </div>

      <div className="flex items-center gap-4">
        <Slider
          min={min}
          max={max}
          step={step}
          value={[value]}
          onValueChange={(values) => onChange(values[0])}
          className="flex-1"
        />
        <div
          className={`flex items-center gap-1 rounded-lg border bg-background ${
            isMobile ? 'min-w-[60px] px-2 py-0.5' : 'min-w-[70px] px-2 py-1'
          }`}
        >
          <span className={`font-bold text-high-emphasis ${isMobile ? 'text-sm' : 'text-base'}`}>
            {formatValue(value)}
          </span>
          <span className={`text-medium-emphasis ${isMobile ? 'text-xs' : 'text-xs'}`}>
            / {formatValue(max)}
          </span>
        </div>
      </div>
    </div>
  );
};
